export function initSiteHeader() {
    // Smooth-scroll for hashbang links in frontpage nav
    document.querySelectorAll('.site-header__nav--frontpage a[href^="#"]').forEach((link) => {
        link.addEventListener('click', (e) => {
            const href = link.getAttribute('href');
            if (href === '#' || href.length < 2) return;

            const target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                history.pushState(null, '', href);
            }
        });
    });
}
